<template>
  <layout>
    <rdkm-title>
      {{ $t('Обновления статусов у доноров') }}
    </rdkm-title>    
  </layout>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import Constants from '../../constants';
import { EventBus } from '../../event-bus';

export default {
  props: ['query'],  
  data() {
    return {};
  },
  created() {
    EventBus.$emit('showThrobber');

    axios.get('/donors/UpdateDonorsState').then((response) => {
      EventBus.$emit('success', { msg: this.$t('Доноры успешно обновлены!') });
      EventBus.$emit('hideThrobber');
    });
  }
};
</script>
